import { createClient } from "@supabase/supabase-js";

// Single shared Supabase client for the whole app. Credentials come from Vite
// env vars (VITE_-prefixed so they're exposed to the browser bundle):
//   VITE_SUPABASE_URL       — the project URL
//   VITE_SUPABASE_ANON_KEY  — the public anon key (safe to ship; RLS guards data)
// Both live in .env (gitignored); see .env.example for the names.
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Fail loud-but-friendly if the env isn't wired up, rather than letting the
// client construct with `undefined` and surface a cryptic error on first call.
if (!url || !anonKey) {
	const missing = [
		!url && "VITE_SUPABASE_URL",
		!anonKey && "VITE_SUPABASE_ANON_KEY",
	]
		.filter(Boolean)
		.join(", ");
	throw new Error(
		`Supabase is not configured: missing ${missing}. ` +
			`Copy .env.example to .env and fill in the values from your Supabase ` +
			`project (Settings → API).`,
	);
}

// persistSession + autoRefreshToken are the supabase-js defaults (session is
// kept in localStorage and refreshed in the background); stated explicitly here
// so the intent is obvious. detectSessionInUrl handles the password-reset link,
// which lands back on the app with the recovery token in the URL hash.
export const supabase = createClient(url, anonKey, {
	auth: {
		persistSession: true,
		autoRefreshToken: true,
		detectSessionInUrl: true,
	},
});
